import React, { FC, useContext } from 'react'
import { ChatContext } from '~/service/chatConn'
import { FormType } from '.'
import { UseFormSetValue } from 'react-hook-form'
import { Attachment } from '~/components/common/upload'
import filesize from 'filesize'

type AttachmentsProps = {
  attachments: Attachment[]
  setValue: UseFormSetValue<FormType>
}

const Attachments: FC<AttachmentsProps> = ({ attachments, setValue }) => (
  <div className="chat-input-attachments">
    {attachments.map((attachment, index) => (
      <Attachment
        attachment={attachment}
        key={index}
        remove={() => {
          setValue(
            'attachments',
            attachments.filter(a => a != attachment)
          )
        }}
      />
    ))}
  </div>
)

export default Attachments

//

type AttachmentProps = {
  attachment: Attachment
  remove: () => void
}

const Attachment: FC<AttachmentProps> = ({ attachment, remove }) => (
  <div className="chat-input-attachments-item">
    {attachment.uploading ? (
      <div className="chat-input-attachments-item-loading">
        <span className="fa fa-spinner fa-spin" />
      </div>
    ) : attachment.isImage ? (
      <div
        className="chat-input-attachments-item-preview"
        style={{ backgroundImage: `url(${attachment.url})` }}
      />
    ) : (
      <div className="chat-input-attachments-item-icon">
        <span className={'fal ' + attachment.icon} />
      </div>
    )}

    <div className="chat-input-attachments-item-name">
      <a href={attachment.url} target="_blank">
        {attachment.name}
      </a>
      <div className="chat-input-attachments-item-name-size">
        (
        {filesize(attachment.size, {
          standard: 'jedec',
          round: 0,
        })}
        )
      </div>
      <a
        onClick={e => {
          e.preventDefault()
          remove()
        }}
      >
        <span className="fa fa-remove" />
      </a>
    </div>
  </div>
)

//
